<template>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="table-svg-path" d="M13.8105 1.5C13.6186 1.5 13.4265 1.5731 13.2803 1.71973L12 3L15 6L16.2803 4.71973C16.5735 4.42648 16.5735 3.95168 16.2803 3.65918L14.3408 1.71973C14.1942 1.5731 14.0025 1.5 13.8105 1.5ZM10.875 4.125L2.25 12.75V15.75H5.25L13.875 7.125L10.875 4.125Z"
              fill="CurrentColor"/>
    </svg>
</template>

<script>
    export default {
        name: "SVGAdminEditRow"
    }
</script>

<style scoped>

</style>
